export class TestInstruction {

    Id: number;
    TestId?:number;
    Active?:number;
    LookupId?:number;

    constructor() {
    }
}